var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 2)",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 18,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 18h7v2m-3-2v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 13.056V9.444A1.45 1.45 0 0 1 6.455 8h13.09A1.45 1.45 0 0 1 21 9.444v10.112A1.45 1.45 0 0 1 19.545 21h-4.363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8V4.667C8 2.089 10.239 0 13 0s5 2.09 5 4.667V8M13 12v3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14 1.5c3.03 0 5.5 2.305 5.5 5.167V9.5h1.045a1.95 1.95 0 0 1 1.95 1.8l.005.144v10.112a1.95 1.95 0 0 1-1.955 1.944h-4.363a.5.5 0 1 1 0-1h4.363a.95.95 0 0 0 .955-.944V11.444a.95.95 0 0 0-.955-.944H7.455a.95.95 0 0 0-.955.944v3.612a.5.5 0 0 1-1 0v-3.612A1.95 1.95 0 0 1 7.455 9.5H8.5V6.667c0-2.79 2.348-5.051 5.274-5.163zm0 12a.5.5 0 0 1 .5.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 0 1 .5-.5zm0-11c-2.493 0-4.5 1.873-4.5 4.167V9.5h9V6.667c0-2.226-1.891-4.056-4.281-4.162z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 23.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zm0-6a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm10 2a.5.5 0 0 1 .492.41l.008.09v2a.5.5 0 0 1-.992.09L13.5 22v-1.5h-2v.5a.5.5 0 0 1-.992.09L10.5 21v-.5H7a.5.5 0 0 1-.492-.41L6.5 20a.5.5 0 0 1 .41-.492L7 19.5h7z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.9919c7c56d0ab4765de340d5ecc1137c.svg";
export { ForwardRef as ReactComponent };